import { c as _c } from "react/compiler-runtime";
import { OptionCard } from "@justhome/react-ui";
import React, { forwardRef, PropsWithChildren } from "react";
export type ToggleOptionCardGroupValue = any;
export type ToggleOptionCardGroupProps = {
  name?: string;
  value?: ToggleOptionCardGroupValue | ToggleOptionCardGroupValue[];
  onChange?: any;
  type?: "checkbox" | "radio";
  ref?: any;
  className?: string;
  label?: string;
};
const ToggleOptionCardGroup = forwardRef<HTMLDivElement | null, PropsWithChildren<ToggleOptionCardGroupProps>>(function ToggleOptionCardGroup(t0, ref) {
  const $ = _c(26);
  const {
    children,
    name,
    value,
    onChange,
    type: t1,
    className,
    label
  } = t0;
  const type = t1 === undefined ? "radio" : t1;
  let t2;
  if ($[0] !== value) {
    t2 = () => value == null ? [] : [].concat(value);
    $[0] = value;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const getValues = t2;
  let t3;
  if ($[2] !== getValues || $[3] !== onChange || $[4] !== type) {
    t3 = (inputVal, event) => {
      if (!onChange) {
        return;
      }
      const values = getValues();
      const isActive = values.indexOf(inputVal) !== -1;
      if (type === "radio") {
        if (!isActive && onChange) {
          onChange(inputVal, event);
        }
        return;
      }
      if (isActive) {
        onChange(values.filter(n => n !== inputVal), event);
      } else {
        onChange([...values, inputVal], event);
      }
    };
    $[2] = getValues;
    $[3] = onChange;
    $[4] = type;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const handleToggle = t3;
  if (!Array.isArray(children)) {
    if (process.env.NODE_ENV === "production") {
      return null;
    }
    throw new Error("Invalid child elements, only an array of components");
  }
  let t4;
  if ($[6] !== label) {
    t4 = label && <label className="block text-title-1 mb-2xs">{label}</label>;
    $[6] = label;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== children || $[9] !== getValues || $[10] !== handleToggle || $[11] !== name || $[12] !== type) {
    let t6;
    if ($[14] !== getValues || $[15] !== handleToggle || $[16] !== name || $[17] !== type) {
      t6 = child => {
        if (React.isValidElement(child)) {
          const values_0 = getValues();
          const props = child.props;
          const {
            value: childVal,
            onChange: childOnChange
          } = props;
          return React.cloneElement(child as React.ReactElement<any>, {
            checked: values_0.indexOf(childVal) !== -1,
            name,
            type,
            onChange: e => {
              handleToggle(childVal, e);
              if (childOnChange) {
                childOnChange();
              }
            }
          });
        }
        return null;
      };
      $[14] = getValues;
      $[15] = handleToggle;
      $[16] = name;
      $[17] = type;
      $[18] = t6;
    } else {
      t6 = $[18];
    }
    t5 = children.map(t6);
    $[8] = children;
    $[9] = getValues;
    $[10] = handleToggle;
    $[11] = name;
    $[12] = type;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[19] !== className || $[20] !== t5) {
    t6 = <div className={className}>{t5}</div>;
    $[19] = className;
    $[20] = t5;
    $[21] = t6;
  } else {
    t6 = $[21];
  }
  let t7;
  if ($[22] !== ref || $[23] !== t4 || $[24] !== t6) {
    t7 = <div ref={ref}>{t4}{t6}</div>;
    $[22] = ref;
    $[23] = t4;
    $[24] = t6;
    $[25] = t7;
  } else {
    t7 = $[25];
  }
  return t7;
});
export default Object.assign(ToggleOptionCardGroup, {
  Option: OptionCard
});